import ProfileHomeCard from '@/modules/home/components/ProfileHomeCard';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import Links from '@/shared/constants/navegacao';
import { useEffect } from 'react';
import { BiListUl } from 'react-icons/bi';
import { LuFileSearch, LuGauge, LuMail, LuScrollText, LuTimer } from 'react-icons/lu';

const CARDS = [
  {
    label: 'Logs de Uso',
    description: 'Alterações feitas no sistema, com usuário, data e valores.',
    to: Links.Auditorias_LogsUso,
    icon: LuFileSearch,
  },
  {
    label: 'Logs de E-mails',
    description: 'Envios de e-mail registrados pela aplicação.',
    to: Links.Auditorias_LogsEmails,
    icon: LuMail,
  },
  {
    label: 'Logs de Tarefas',
    description: 'Execução das tarefas automáticas da API.',
    to: Links.Auditorias_LogsTasks,
    icon: LuTimer,
  },
  {
    label: 'Rate Limit',
    description: 'Bloqueios quando o limite de requisições foi excedido.',
    to: Links.Auditorias_RateLimit,
    icon: LuGauge,
  },
  {
    label: 'Relatórios',
    description: 'Quem gerou relatórios, os filtros usados e o tempo da consulta.',
    to: Links.Auditorias_Relatorios,
    icon: LuScrollText,
  },
];

export default function AuditoriasIndexPage() {
  const { setActions } = useBreadcrumbActions();

  useEffect(() => {
    const acao = (label: string, href: string) => ({
      label,
      onClick: () => {},
      href,
      icon: BiListUl,
    });

    setActions({
      report: acao('Logs de Uso', Links.Auditorias_LogsUso),
      primary: acao('Logs de E-mails', Links.Auditorias_LogsEmails),
      secondary: acao('Logs de Tarefas', Links.Auditorias_LogsTasks),
      tertiary: acao('Rate Limit', Links.Auditorias_RateLimit),
      print: acao('Relatórios', Links.Auditorias_Relatorios),
    });
    return () => setActions({});
  }, [setActions]);

  return (
    <div className="row">
      <div className="col-12">
        <h3>Auditorias</h3>
        <span className="blockquote-footer pb-4 text-end">Selecione o tipo de log para consulta.</span>
      </div>
      <div className="col-12">
        <div className="escolha-modulo-wrap escolha-modulo-wrap--profile-home">
          <ul className="escolha-modulo-grid escolha-modulo-grid--3cols">
            {CARDS.map((card) => (
              <li key={card.to}>
                <ProfileHomeCard
                  label={card.label}
                  description={card.description}
                  to={card.to}
                  icon={card.icon}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
